<nz-footer>
  <div class="copyright">{{ 'app.label.developer' | translate }}{{date?.getFullYear()}}</div>
  <nz-select style="display: none" [(ngModel)]="selectedDb" (ngModelChange)="onDbChange($event)" nzSize="small">
    <nz-option *ngFor="let opt of dbOptions" [nzValue]="opt" [nzLabel]="opt"></nz-option>
  </nz-select>
  <div class="version" (click)="onAppVersionClick()" style="cursor: pointer;">{{ appVersion }}</div>
</nz-footer>
